export { Divider, StackDivider } from '@chakra-ui/react';
export type { DividerProps, StackDividerProps } from '@chakra-ui/react';
